import {IDictionary, ISubNavigationItem} from "modules/types";
import {ProjectName} from "modules/enums";
import {IS_SPONSOR_ENABLED} from "apps/GAME_ZONE/modules/constants";
import {IS_LIVE_BRACKET_ENABLED} from "apps/BRACKET_PREDICTOR/modules/constants";

const LeaguesLink = "/leagues";
const LeaguesJoinLink = "/leagues/join";
const LeaguesCreateLink = "/leagues/create";

const hyundaiLeagueCopy = "landing.nav.gotc_league";
const hyundaiLeagueLink = "/hyundai-league";

const helpLink = "/help";
const rulesLink = "/help/rules";
const prizesLink = "/help/prizes";
const faqLink = "/help/faqs";
const contactLink = "/help/contact";
const tcLink = "/help/terms-of-service";
const bracketsLink = "/brackets";
const liveBracketsLink = "/live-brackets";

const leaguesCopy = "landing.nav.leagues";
const myTeamCopy = "landing.nav.my_team";
const myLeaguesDropdownCopy = "landing.nav_leagues_drop_down.my_leagues";
const joinLeaguesDropdownCopy = "landing.nav_drop_down.join";
const createLeaguesDropdownCopy = "landing.nav_leagues_drop_down.create";
const leaguesLeaderboardCopy = "landing.nav.leaderboard";

const helpCopy = "landing.nav.help";
const rulesCopy = "landing.nav_help_drop_down.rules";
const prizesCopy = "landing.nav_help_drop_down.prizes";
const faqCopy = "landing.nav_help_drop_down.faq";
const contactCopy = "landing.nav_help_drop_down.contact";
const tcCopy = "landing.nav_help_drop_down.t&c";

const matchPredictorCustomClass = "match-predictor";
const bracketPredictorCustomClass = "bracket-predictor";
const whoamiCustomClass = "who_am_i";
const goalScorerCustomClass = "goalscorer";

const FIVES_CLASSIC_BASE_URL = "/fives";
const FANTASY_CLASSIC_BASE_URL = "/fantasy-classic";
const FANTASY_DAILY_BASE_URL = "/fantasy-daily";
const MATCH_PREDICTOR_BASE_URL = "/match-predictor";
const BRACKET_PREDICTOR_BASE_URL = "/bracket-predictor";
const WHOAMI_BASE_URL = "/whoami";
const GOTT_BASE_URL = "/gott";
const GOALSCORER_BASE_URL = "/goalscorer";

const TRIVIA_SUB_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "subheader.fifa.help",
		to: "/help",
		href: "/trivia/help",
		clickable: true,
		projectName: ProjectName.Trivia,
		customClass: "trivia",
	},
];

const BRACKETS_SUB_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "subheader.fifa.help",
		to: "/help",
		href: "/content-bracket/help",
		clickable: true,
		projectName: ProjectName.Brackets,
		customClass: "brackets",
	},
];

const FIVES_SUB_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "summary.nav.leagues",
		href: FIVES_CLASSIC_BASE_URL + LeaguesLink,
		to: LeaguesLink,
		projectName: ProjectName.Fives,
		customClass: "fives",
		authorizationRequired: true,
		subItems: [
			{
				name: "leagues.nav.myleagues",
				href: FIVES_CLASSIC_BASE_URL + LeaguesLink,
				to: LeaguesLink,
				projectName: ProjectName.Fives,
			},
			{
				name: "leagues.nav.createleague",
				href: FIVES_CLASSIC_BASE_URL + LeaguesJoinLink,
				to: LeaguesJoinLink,
				projectName: ProjectName.Fives,
			},
			{
				name: "leagues.nav.joinleague",
				href: FIVES_CLASSIC_BASE_URL + LeaguesCreateLink,
				to: LeaguesCreateLink,
				projectName: ProjectName.Fives,
			},
		],
	},
	{
		name: "summary.nav.leaderboard",
		href: FIVES_CLASSIC_BASE_URL + "/rankings",
		to: "/rankings",
		projectName: ProjectName.Fives,
		customClass: "fives",
		authorizationRequired: true,
	},
	{
		name: "summary.nav.help",
		href: FIVES_CLASSIC_BASE_URL + "/help",
		to: "/help",
		clickable: true,
		projectName: ProjectName.Fives,
	},
];

const HYUNDAI_SUB_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "summary.nav.editorial",
		href: "/hyundai-quiz/editorial",
		to: "/editorial",
		clickable: true,
		projectName: ProjectName.HyundaiQuiz,
	},
	{
		name: "summary.nav.help",
		href: "/hyundai-quiz/help",
		to: "/help",
		clickable: true,
		projectName: ProjectName.HyundaiQuiz,
	},
];

const FANTASY_CLASSIC_NAVIGATION: ISubNavigationItem[] = [
	{
		name: myTeamCopy,
		href: FANTASY_CLASSIC_BASE_URL + "/team",
		to: "/team",
		projectName: ProjectName.Fantasy,
		customClass: "fantasy",
	},
	{
		name: leaguesCopy,
		href: FANTASY_CLASSIC_BASE_URL + LeaguesLink,
		to: LeaguesLink,
		projectName: ProjectName.Fantasy,
		customClass: "fantasy",
		authorizationRequired: true,
		subItems: [
			{
				name: myLeaguesDropdownCopy,
				href: FANTASY_CLASSIC_BASE_URL + LeaguesLink,
				to: LeaguesLink,
				projectName: ProjectName.Fantasy,
			},
			{
				name: joinLeaguesDropdownCopy,
				href: FANTASY_CLASSIC_BASE_URL + LeaguesJoinLink,
				to: LeaguesJoinLink,
				projectName: ProjectName.Fantasy,
			},
			{
				name: createLeaguesDropdownCopy,
				href: FANTASY_CLASSIC_BASE_URL + LeaguesCreateLink,
				to: LeaguesCreateLink,
				projectName: ProjectName.Fantasy,
			},
		],
	},
	{
		name: leaguesLeaderboardCopy,
		href: FANTASY_CLASSIC_BASE_URL + "/rankings",
		to: "/rankings",
		projectName: ProjectName.Fantasy,
		customClass: "fantasy",
		authorizationRequired: true,
	},
	{
		name: helpCopy,
		href: FANTASY_CLASSIC_BASE_URL + helpLink,
		to: helpLink,
		clickable: true,
		projectName: ProjectName.Fantasy,
		customClass: "fantasy",
		subItems: [
			{
				name: rulesCopy,
				href: FANTASY_CLASSIC_BASE_URL + rulesLink,
				to: rulesLink,
				projectName: ProjectName.Fantasy,
			},
			{
				name: faqCopy,
				href: FANTASY_CLASSIC_BASE_URL + faqLink,
				to: faqLink,
				projectName: ProjectName.Fantasy,
			},
			{
				name: contactCopy,
				href: FANTASY_CLASSIC_BASE_URL + contactLink,
				to: contactLink,
				projectName: ProjectName.Fantasy,
			},
			{
				name: prizesCopy,
				href: FANTASY_CLASSIC_BASE_URL + prizesLink,
				to: prizesLink,
				projectName: ProjectName.Fantasy,
			},
		],
	},
];

const FANTASY_DAILY_NAVIGATION: ISubNavigationItem[] = [
	{
		name: myTeamCopy,
		href: FANTASY_DAILY_BASE_URL + "/team",
		to: "/team",
		projectName: ProjectName.FantasyDaily,
		customClass: "fantasy_daily",
	},
	{
		name: leaguesCopy,
		href: FANTASY_DAILY_BASE_URL + LeaguesLink,
		to: LeaguesLink,
		projectName: ProjectName.FantasyDaily,
		customClass: "fantasy_daily",
		authorizationRequired: true,
		subItems: [
			{
				name: myLeaguesDropdownCopy,
				href: FANTASY_DAILY_BASE_URL + LeaguesLink,
				to: LeaguesLink,
				projectName: ProjectName.FantasyDaily,
			},
			{
				name: joinLeaguesDropdownCopy,
				href: FANTASY_DAILY_BASE_URL + LeaguesJoinLink,
				to: LeaguesJoinLink,
				projectName: ProjectName.FantasyDaily,
			},
			{
				name: createLeaguesDropdownCopy,
				href: FANTASY_DAILY_BASE_URL + LeaguesCreateLink,
				to: LeaguesCreateLink,
				projectName: ProjectName.FantasyDaily,
			},
		],
	},
	{
		name: leaguesLeaderboardCopy,
		href: FANTASY_DAILY_BASE_URL + "/rankings",
		to: "/rankings",
		projectName: ProjectName.FantasyDaily,
		customClass: "fantasy_daily",
		authorizationRequired: true,
	},
	{
		name: helpCopy,
		href: FANTASY_DAILY_BASE_URL + helpLink,
		to: helpLink,
		clickable: true,
		projectName: ProjectName.FantasyDaily,
		customClass: "fantasy_daily",
		subItems: [
			{
				name: rulesCopy,
				href: FANTASY_DAILY_BASE_URL + rulesLink,
				to: rulesLink,
				projectName: ProjectName.FantasyDaily,
			},
			{
				name: prizesCopy,
				href: FANTASY_DAILY_BASE_URL + prizesLink,
				to: prizesLink,
				projectName: ProjectName.FantasyDaily,
			},
			{
				name: faqCopy,
				href: FANTASY_DAILY_BASE_URL + faqLink,
				to: faqLink,
				projectName: ProjectName.FantasyDaily,
			},
			{
				name: contactCopy,
				href: FANTASY_DAILY_BASE_URL + contactLink,
				to: contactLink,
				projectName: ProjectName.FantasyDaily,
			},
			{
				name: tcCopy,
				href: FANTASY_DAILY_BASE_URL + tcLink,
				to: tcLink,
				projectName: ProjectName.FantasyDaily,
			},
		],
	},
];

const MATCH_PREDICTOR_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "landing.nav.match",
		href: MATCH_PREDICTOR_BASE_URL + "/match",
		to: "/match",
		projectName: ProjectName.MatchPredictor,
		customClass: matchPredictorCustomClass,
	},
	{
		name: hyundaiLeagueCopy,
		href: MATCH_PREDICTOR_BASE_URL + hyundaiLeagueLink,
		to: hyundaiLeagueLink,
		projectName: ProjectName.MatchPredictor,
		customClass: "fourth_step",
		authorizationRequired: true,
		// hidden: false,
	},
	{
		name: leaguesCopy,
		href: MATCH_PREDICTOR_BASE_URL + LeaguesLink,
		to: LeaguesLink,
		projectName: ProjectName.MatchPredictor,
		customClass: "five_step",
		authorizationRequired: true,
		subItems: [
			{
				name: myLeaguesDropdownCopy,
				href: MATCH_PREDICTOR_BASE_URL + LeaguesLink,
				to: LeaguesLink,
				projectName: ProjectName.MatchPredictor,
			},
			{
				name: joinLeaguesDropdownCopy,
				href: MATCH_PREDICTOR_BASE_URL + LeaguesJoinLink,
				to: LeaguesJoinLink,
				projectName: ProjectName.MatchPredictor,
			},
			{
				name: createLeaguesDropdownCopy,
				href: MATCH_PREDICTOR_BASE_URL + LeaguesCreateLink,
				to: LeaguesCreateLink,
				projectName: ProjectName.MatchPredictor,
			},
		],
	},
	{
		name: leaguesLeaderboardCopy,
		href: MATCH_PREDICTOR_BASE_URL + "/rankings",
		to: "/rankings",
		projectName: ProjectName.MatchPredictor,
		customClass: matchPredictorCustomClass,
		authorizationRequired: true,
	},
	{
		name: helpCopy,
		href: MATCH_PREDICTOR_BASE_URL + helpLink,
		to: helpLink,
		clickable: true,
		projectName: ProjectName.MatchPredictor,
		customClass: matchPredictorCustomClass,
		subItems: [
			{
				name: rulesCopy,
				href: MATCH_PREDICTOR_BASE_URL + rulesLink,
				to: rulesLink,
				projectName: ProjectName.MatchPredictor,
			},
			{
				name: prizesCopy,
				href: MATCH_PREDICTOR_BASE_URL + prizesLink,
				to: prizesLink,
				projectName: ProjectName.MatchPredictor,
			},
			{
				name: faqCopy,
				href: MATCH_PREDICTOR_BASE_URL + faqLink,
				to: faqLink,
				projectName: ProjectName.MatchPredictor,
			},
			{
				name: contactCopy,
				href: MATCH_PREDICTOR_BASE_URL + contactLink,
				to: contactLink,
				projectName: ProjectName.MatchPredictor,
			},
			{
				name: tcCopy,
				href: MATCH_PREDICTOR_BASE_URL + tcLink,
				to: tcLink,
				projectName: ProjectName.MatchPredictor,
			},
		],
	},
];

const WHOAMI_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "landing.nav.my_guesses",
		href: WHOAMI_BASE_URL + "/game",
		to: "/game",
		projectName: ProjectName.WhoAmI,
		customClass: whoamiCustomClass,
	},
	{
		name: leaguesLeaderboardCopy,
		href: WHOAMI_BASE_URL + "/rankings",
		to: "/rankings",
		projectName: ProjectName.WhoAmI,
		customClass: "fantasy",
		authorizationRequired: true,
	},
	{
		name: helpCopy,
		href: WHOAMI_BASE_URL + helpLink,
		to: helpLink,
		clickable: true,
		projectName: ProjectName.WhoAmI,
		customClass: whoamiCustomClass,
		subItems: [
			{
				name: rulesCopy,
				href: WHOAMI_BASE_URL + rulesLink,
				to: rulesLink,
				projectName: ProjectName.WhoAmI,
			},
			{
				name: faqCopy,
				href: WHOAMI_BASE_URL + faqLink,
				to: faqLink,
				projectName: ProjectName.WhoAmI,
			},
			{
				name: contactCopy,
				href: WHOAMI_BASE_URL + contactLink,
				to: contactLink,
				projectName: ProjectName.WhoAmI,
			},
		],
	},
];

const GOTT_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "landing.nav.my_votes",
		fallbackName: "Votes",
		href: GOTT_BASE_URL + "/game",
		to: "/",
		projectName: ProjectName.Gott,
	},
	{
		name: helpCopy,
		href: GOTT_BASE_URL + helpLink,
		to: helpLink,
		clickable: true,
		projectName: ProjectName.Gott,
		customClass: whoamiCustomClass,
		subItems: [
			{
				name: rulesCopy,
				href: GOTT_BASE_URL + rulesLink,
				to: rulesLink,
				projectName: ProjectName.Gott,
			},
			{
				name: faqCopy,
				href: GOTT_BASE_URL + faqLink,
				to: faqLink,
				projectName: ProjectName.Gott,
			},
		],
	},
];

const GOALSCORER_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "landing.nav.my_goalscorers",
		fallbackName: "My goalscorers",
		href: GOALSCORER_BASE_URL,
		to: "/",
		projectName: ProjectName.Goalscorer,
	},
	{
		name: leaguesLeaderboardCopy,
		href: GOALSCORER_BASE_URL + "/rankings",
		to: "/rankings",
		projectName: ProjectName.Goalscorer,
		customClass: goalScorerCustomClass,
		authorizationRequired: true,
	},
	{
		name: helpCopy,
		href: GOALSCORER_BASE_URL + helpLink,
		to: helpLink,
		clickable: true,
		projectName: ProjectName.Goalscorer,
		customClass: goalScorerCustomClass,
		subItems: [
			{
				name: rulesCopy,
				href: GOALSCORER_BASE_URL + rulesLink,
				to: rulesLink,
				projectName: ProjectName.Goalscorer,
			},
			{
				name: faqCopy,
				href: GOALSCORER_BASE_URL + faqLink,
				to: faqLink,
				projectName: ProjectName.Goalscorer,
			},
			{
				name: contactCopy,
				href: GOALSCORER_BASE_URL + contactLink,
				to: contactLink,
				projectName: ProjectName.Goalscorer,
			},
		],
	},
];

const BRACKET_PREDICTOR_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "landing.nav.my_bracket",
		href: BRACKET_PREDICTOR_BASE_URL + bracketsLink,
		to: bracketsLink,
		projectName: ProjectName.BracketsPredictor,
		customClass: bracketPredictorCustomClass,
	},
	{
		name: leaguesCopy,
		href: BRACKET_PREDICTOR_BASE_URL + LeaguesLink,
		to: LeaguesLink,
		projectName: ProjectName.BracketsPredictor,
		customClass: bracketPredictorCustomClass,
		authorizationRequired: true,
		subItems: [
			{
				name: myLeaguesDropdownCopy,
				href: BRACKET_PREDICTOR_BASE_URL + LeaguesLink,
				to: LeaguesLink,
				projectName: ProjectName.BracketsPredictor,
			},
			{
				name: joinLeaguesDropdownCopy,
				href: BRACKET_PREDICTOR_BASE_URL + LeaguesJoinLink,
				to: LeaguesJoinLink,
				projectName: ProjectName.BracketsPredictor,
			},
			{
				name: createLeaguesDropdownCopy,
				href: BRACKET_PREDICTOR_BASE_URL + LeaguesCreateLink,
				to: LeaguesCreateLink,
				projectName: ProjectName.BracketsPredictor,
			},
		],
	},
	{
		name: leaguesLeaderboardCopy,
		href: BRACKET_PREDICTOR_BASE_URL + "/rankings",
		to: "/rankings",
		projectName: ProjectName.BracketsPredictor,
		customClass: bracketPredictorCustomClass,
		authorizationRequired: true,
	},
	{
		name: helpCopy,
		href: BRACKET_PREDICTOR_BASE_URL + helpLink,
		to: helpLink,
		clickable: true,
		projectName: ProjectName.BracketsPredictor,
		customClass: bracketPredictorCustomClass,
	},
];

if (IS_LIVE_BRACKET_ENABLED) {
	BRACKET_PREDICTOR_NAVIGATION.splice(1, 0, {
		name: "landing.nav.my_bracket",
		href: BRACKET_PREDICTOR_BASE_URL + liveBracketsLink,
		to: liveBracketsLink,
		projectName: ProjectName.BracketsPredictor,
		customClass: bracketPredictorCustomClass,
	});
}

const BUDWEISERPOTM_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "landing.subheader.votes",
		href: "/budweiserpotm",
		to: "/",
		projectName: ProjectName.Budweiserpotm,
		customClass: bracketPredictorCustomClass,
	},
	// {
	// 	name: leaguesLeaderboardCopy,
	// 	href: "/",
	// 	to: "/rankings",
	// 	projectName: ProjectName.Budweiserpotm,
	// 	customClass: bracketPredictorCustomClass,
	// 	authorizationRequired: true,
	// },
	{
		name: helpCopy,
		href: "/budweiserpotm" + helpLink,
		to: helpLink,
		clickable: true,
		projectName: ProjectName.Budweiserpotm,
		customClass: bracketPredictorCustomClass,
	},
];

const GAME_ZONE_NAVIGATION = IS_SPONSOR_ENABLED
	? [
			{
				name: helpCopy,
				href: helpLink,
				to: helpLink,
				clickable: true,
				projectName: ProjectName.GameZone,
			},
	  ]
	: [];

export const PROJECTS_NAVIGATION_ITEMS: ISubNavigationItem[] = [
	{
		name: "subheader.fifa.play_zone",
		to: "/",
		href: "/",
		projectName: ProjectName.GameZone,
	},
	{
		name: "subheader.fifa.gott_title",
		to: "/",
		href: "/gott/",
		projectName: ProjectName.Gott,
	},
	{
		name: "subheader.fifa.trivia_title",
		to: "/",
		href: "/trivia/",
		projectName: ProjectName.Trivia,
	},
	{
		name: "subheader.fifa.whoami_title",
		to: "/game",
		href: "/whoami/game",
		projectName: ProjectName.WhoAmI,
	},
	{
		name: "subheader.fifa.brackets_title",
		to: "/",
		href: "/content-bracket/",
		projectName: ProjectName.Brackets,
	},
	{
		name: "summary.nav.fives",
		to: "/",
		href: "/fives/",
		projectName: ProjectName.Fives,
		hidden: true,
	},
	{
		name: "subheader.fifa.goalscorer_title",
		to: "/",
		href: "/goalscorer/",
		projectName: ProjectName.Goalscorer,
		hidden: true,
	},
];

export const MOBILE_MENU_NAVIGATION: ISubNavigationItem[] = [
	{
		name: "header.hamburger.play_zone",
		to: "/",
		href: "/",
		projectName: ProjectName.GameZone,
	},
	{
		name: "header.hamburger.gott",
		to: "/",
		href: "/gott/",
		projectName: ProjectName.Gott,
	},
	{
		name: "subheader.fifa.trivia_title",
		to: "/",
		href: "/trivia/",
		projectName: ProjectName.Trivia,
	},
	{
		name: "header.hamburger.who",
		to: "/game",
		href: "/whoami/game",
		projectName: ProjectName.WhoAmI,
	},
	{
		name: "summary.nav.fives",
		to: "/",
		href: "/fives/",
		projectName: ProjectName.Fives,
		subItems: FIVES_SUB_NAVIGATION,
		hidden: true,
	},
	{
		name: "subheader.fifa.brackets_title",
		to: "/",
		href: "/content-bracket/",
		projectName: ProjectName.Brackets,
	},
];

export const SUB_NAVIGATION_ITEMS: {
	[key: string]: ISubNavigationItem[];
} = {
	TRIVIA: TRIVIA_SUB_NAVIGATION,
	FANTASY_CLASSIC: FANTASY_CLASSIC_NAVIGATION,
	FANTASY_DAILY: FANTASY_DAILY_NAVIGATION,
	CONTENT_BRACKET: BRACKETS_SUB_NAVIGATION,
	FIVES: FIVES_SUB_NAVIGATION,
	HYUNDAI_QUIZ: HYUNDAI_SUB_NAVIGATION,
	MATCH_PREDICTOR: MATCH_PREDICTOR_NAVIGATION,
	BRACKET_PREDICTOR: BRACKET_PREDICTOR_NAVIGATION,
	BUDWEISERPOTM: BUDWEISERPOTM_NAVIGATION,
	GAME_ZONE: GAME_ZONE_NAVIGATION,
	WHOAMI: WHOAMI_NAVIGATION,
	GOTT: GOTT_NAVIGATION,
	GOALSCORER: GOALSCORER_NAVIGATION,
};

export const TUTORIAL: IDictionary<boolean | string[]> = {
	CONTENT_BRACKET: true,
	MATCH_PREDICTOR: ["/match"],
	BRACKET_PREDICTOR: [bracketsLink],
	FANTASY_CLASSIC: ["/team"],
	WHOAMI: ["/game"],
	GOTT: ["/game"],
};

export interface IDropDownLink {
	title: string;
	href?: string;
	bgc?: string;
	subLinks?: {
		bgc?: string;
		links: IDropDownLink[];
	};
}

export const MENU_LINKS: IDropDownLink[] = [
	{
		title: "header.fifa.fifa_club_world_cup_2022",
		href: "https://www.fifa.com/fifaplus/en/tournaments/mens/fifa-club-world-cup/morocco-2022",
	},
	{
		title: "header.fifa.fifa_womens_world_cup_2023",
		subLinks: {
			bgc: "#00155f",
			links: [
				{
					title: "header.fifa_second.fifa_womens_world_cup_2023",
					href: "https://www.fifa.com/fifaplus/en/tournaments/womens/womensworldcup/australia-new-zealand2023",
				},
				{
					title: "header.fifa_second.ticketing",
					href: "https://www.fifa.com/fifaplus/en/tournaments/womens/womensworldcup/australia-new-zealand2023/tickets",
				},
			],
		},
	},
	{
		title: "header.fifa.the_best",
		href: "https://www.fifa.com/fifaplus/en/the-best-fifa-football-awards",
	},
	{
		title: "header.fifa.fifa_world_cup_2022",
		subLinks: {
			bgc: "#550065",
			links: [
				{
					title: "header.fifa_second.fifa_world_cup_2022",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022",
				},
				{
					title: "header.fifa_second.teams",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022/teams",
				},
				{
					title: "header.fifa_second.highlights",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022/qatar-highlights",
				},
				{
					title: "header.fifa_second.scores_fixtures",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022/scores-fixtures",
				},
				{
					title: "header.fifa_second.knockout_groups",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022/knockout-and-groups",
				},
			],
		},
	},
	{title: "header.fifa.news", href: "https://www.fifa.com/fifaplus/cat/6afE5rM7TKmprrjyLuDQcV"},
	{
		title: "header.fifa.watch",
		subLinks: {
			bgc: "#00155f",
			links: [
				{
					title: "header.fifa_second.originals",
					href: "https://www.fifa.com/fifaplus/en/originals",
				},
				{
					title: "header.fifa_second.archive",
					href: "https://www.fifa.com/fifaplus/en/archive",
				},
			],
		},
	},
	{
		title: "header.fifa.play",
		subLinks: {
			bgc: "#00155f",
			links: [
				{title: "header.fifa_second.play_zone", href: "https://play.fifa.com/"},
				{title: "header.fifa_second.whoami", href: "https://play.fifa.com/whoami/"},
				{
					title: "header.fifa_second.head_to_head",
					href: "https://play.fifa.com/content-bracket/",
				},
				{title: "header.fifa_second.trivia", href: "https://play.fifa.com/trivia/"},
			],
		},
	},
	{
		title: "header.fifa.match_centre",
		subLinks: {
			bgc: "#00155f",
			links: [
				{
					title: "header.fifa_second.match_centre",
					href: "https://www.fifa.com/fifaplus/en/match-centre",
				},
				{
					title: "header.fifa_second.highlights",
					href: "https://www.fifa.com/fifaplus/en/highlights",
				},
				{
					title: "header.fifa_second.live_streaming",
					href: "https://www.fifa.com/fifaplus/en/live",
				},
			],
		},
	},
];

export const DROPDOWN_MENU_LINKS: IDropDownLink[] = [
	{
		title: "header.dropdown.home",
		href: "https://www.fifa.com/fifaplus/en/home",
	},
	{
		title: "header.dropdown.fifa_club_world_cup_2022",
		href: "https://www.fifa.com/fifaplus/en/tournaments/mens/fifa-club-world-cup/morocco-2022",
	},
	{
		title: "header.dropdown.fifa_womens_world_cup_2023",
		subLinks: {
			bgc: "#00155F",
			links: [
				{
					title: "header.dropdown_second.fifa_womens_world_cup_2023",
					href: "https://www.fifa.com/fifaplus/en/tournaments/womens/womensworldcup/australia-new-zealand2023",
				},
				{
					title: "header.dropdown_second.ticketing",
					href: "https://www.fifa.com/fifaplus/en/tournaments/womens/womensworldcup/australia-new-zealand2023/tickets",
				},
			],
		},
	},
	{
		title: "header.dropdown.the_best",
		href: "https://www.fifa.com/fifaplus/en/the-best-fifa-football-awards",
	},
	{
		title: "header.dropdown.fifa_world_cup_2022",
		subLinks: {
			bgc: "#550065",
			links: [
				{
					title: "header.dropdown_second.fifa_world_cup_2022",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022",
				},
				{
					title: "header.dropdown_second.highlights",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022/qatar-highlights",
				},
				{
					title: "header.dropdown_second.teams",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022/teams",
				},
				{
					title: "header.dropdown_second.match_schedule",
					href: "https://www.fifa.com/fifaplus/en/match-centre?date=2022-11-20&tab=matchCentreFixtures&country=AL&wtw-filter=ALL",
				},
				{
					title: "header.dropdown_second.knockout_groups",
					href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022/knockout-and-groups",
				},
				{
					title: "header.dropdown_second.more",
					subLinks: {
						bgc: "#773384",
						links: [
							{
								title: "header.dropdown_third.fan_festival",
								href: "https://www.fifa.com/fifaplus/en/fifa-fan-festival",
							},
							{
								title: "header.dropdown_third.trophy_tour",
								href: "https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022/fifaworldcuptrophytour",
							},
							{
								title: "header.dropdown_third.fan_world_cup",
								href: "https://www.fifa.com/fifaplus/en/articles/fifa-fan-world-cup",
							},
							{
								title: "header.dropdown_third.sound",
								href: "https://www.fifa.com/fifaplus/en/fifa-sound",
							},
						],
					},
				},
			],
		},
	},
	{
		title: "header.dropdown.news",
		href: "https://www.fifa.com/fifaplus/cat/6afE5rM7TKmprrjyLuDQcV",
	},
	{
		title: "header.dropdown.originals",
		href: "https://www.fifa.com/fifaplus/en/originals",
	},
	{
		title: "header.dropdown.archive",
		href: "https://www.fifa.com/fifaplus/en/archive",
	},
	{
		title: "header.dropdown.play",
		subLinks: {
			bgc: "#00155F",
			links: [
				{
					title: "header.dropdown_second.playzone",
					href: "https://play.fifa.com/",
				},
				{
					title: "header.dropdown_second.whoami",
					href: "https://play.fifa.com/whoami/",
				},
				{
					title: "header.dropdown_second.metaverse",
					subLinks: {
						bgc: "#00287A",
						links: [
							{
								title: "header.dropdown_third.roblox",
								href: "https://www.roblox.com/games/9486506804/FIFA-World",
							},
							{
								title: "header.dropdown_third.ai_league",
								href: "https://fifaworldcupaileague.com/?utm_source=fifa_website&utm_medium=link_click&utm_campaign=fifa_official_site",
							},
							{
								title: "header.dropdown_third.upland",
								href: "https://www.upland.me/fifa",
							},
							{
								title: "header.dropdown_third.own_the_zone",
								href: "https://www.ownthezone.io/",
							},
							{
								title: "header.dropdown_third.tifo",
								href: "https://www.tifoworldcup.com/",
							},
						],
					},
				},
			],
		},
	},
	{
		title: "header.dropdown.match_centre",
		subLinks: {
			bgc: "#00155F",
			links: [
				{
					title: "header.dropdown_second.match_centre",
					href: "https://www.fifa.com/fifaplus/en/match-centre",
				},
				{
					title: "header.dropdown_second.live_streaming",
					href: "https://www.fifa.com/fifaplus/en/live",
				},
				{
					title: "header.dropdown_second.highlights",
					href: "https://www.fifa.com/fifaplus/en/highlights",
				},
			],
		},
	},
	{
		title: "header.dropdown.more",
		subLinks: {
			bgc: "#00155F",
			links: [
				{
					title: "header.dropdown_second.tournaments",
					href: "https://www.fifa.com/fifaplus/en/tournaments",
				},
				{
					title: "header.dropdown_second.member_associations",
					href: "https://www.fifa.com/fifaplus/en/member-associations",
				},
				{
					title: "header.dropdown_second.volunteers",
					href: "https://www.fifa.com/fifaplus/en/volunteers",
				},
				{
					title: "header.dropdown_second.about",
					href: "https://www.fifa.com/fifaplus/en/about",
				},
			],
		},
	},
];
